import { getQueryClient } from '@/context/ReactQueryProvider';
import { clearSnapWalletInventoryCache } from '@/lib/snap-wallet-reader';

import { QueryKeys } from './api/query-keys';

const inputQueries = new Set<string>([
  QueryKeys.walletBalance,
  QueryKeys.walletAssets,
  QueryKeys.walletCoinUtxos,
  QueryKeys.snapWalletInventory,
  QueryKeys.accountVaultList,
]);

/** Discard rejected inputs before refetching; invalidation alone keeps stale quotes usable. */
export function refreshSpentWalletInputs() {
  clearSnapWalletInventoryCache();
  return getQueryClient().resetQueries({
    predicate: (query) => typeof query.queryKey[0] === 'string' && inputQueries.has(query.queryKey[0]),
  });
}
